import React from 'react';
import PropTypes from 'prop-types';

import '../global-sass/main.scss';

export default class Options extends React.Component {
	render() {
		const accessories = this.props.options.map(item => {
			return (
				<li className="mb-4 text-muted" key={item.id}>
					{item.text}
				</li>
			);
		});
		return <ul className="list-unstyled">{accessories}</ul>;
	}
}

Options.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			id: PropTypes.number.isRequired
		})
	).isRequired
};



// WEBPACK FOOTER //
// ./src/components/Options.jsx